import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'reactstrap';
import moment from 'moment';

import Table, { ExpandedRow, ExpandableRow } from '../../components/ExpandableTable';

import SolicitacaoAguaMineral from './SolicitacaoAguaMineral';

import actions from './actions';

class ListaConsumo extends Component {
  componentDidMount () {
    this.props.actions.onLoadConsumoAguaMineral();
    this.props.actions.onLoadConsumoAguaMineralMarca();
  }

  dateFormat (value) {
    return !!value && moment(value).format("DD/MM/YYYY HH:mm");
  }

  solicita = value => {
    this.props.actions.solicitaAguaMineral(value).then(() => {
      this.props.actions.onLoadConsumoAguaMineralIfNeeded();
    });
  };

  render() {
    const { value: { result, fetching }, actions, marca, marcas } = this.props;

    return (
      <Table async hover responsive size="sm">
        <thead>
          <tr>
            <th colSpan="2">Água Mineral</th>
            <th colSpan="2" className="text-right"><Button color="link" size="sm" onClick={actions.onLoadConsumoAguaMineralIfNeeded}><span className={"fa fa-sync" + (1 === fetching?" fa-spin":"")} /></Button></th>
          </tr>
          <tr>
            <th className="d-none d-sm-table-cell">Unidade</th>
            <th>Compet.</th>
            <th>Produto</th>
            <th className="text-right">Total</th>
          </tr>
        </thead>
        {result.map((v, i) => (
          <ExpandableRow key={i} onExpand={expanded => {
            if (expanded) {
              return this.props.actions.onLoadDetalheConsumoAguaMineral(v);
            }
            return Promise.resolve();
          }}>
            <td className="d-none d-sm-table-cell">{v.unidade}</td>
            <td>{moment(v.competencia).format('MM/YYYY')}</td>
            <td>{v.nome_produto}</td>
            <td className="text-right">{v.total_entregue} / {v.total_solicitado}</td>
            <ExpandedRow>
              {!v.detail && "Reabra o detalhe para visualizar os dados atualizados."}
              {v.detail && <Table>
                <thead>
                  <tr>
                    <th>Solicitação</th>
                    <th>Confirmação</th>
                    <th>Entrega</th>
                  </tr>
                </thead>
                <tbody>
                  {v.detail.result.map((detail, i) => (<tr key={i}>
                    <td>{this.dateFormat(detail.data_solicitacao)}<br />{detail.solicitante}</td>
                    <td>{this.dateFormat(detail.data_confirmacao)}<br />{detail.contratado}</td>
                    <td>{this.dateFormat(detail.data_entrega)}<br />{detail.entregador}</td>
                  </tr>))}
                </tbody>
              </Table>}
            </ExpandedRow>
          </ExpandableRow>
        ))}
        <tfoot>
          <tr>
            <td colSpan="4" key={marca}>
              <SolicitacaoAguaMineral disabled={1 === fetching} defaultValue={marca} options={marcas} onSubmit={this.solicita} />
            </td>
          </tr>
        </tfoot>
      </Table>
    );
  }
}

let mapStateToProps = ({ consumo: { marca, marcas, aguaMineral } }) => ({
  marcas: marcas.result.options,
  marca,
  value: aguaMineral
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaConsumo);



// WEBPACK FOOTER //
// ./src/modules/consumo/ListaConsumoAguaMineral.js